import { useDroppable } from "@dnd-kit/core";
import { FloatingToolbar } from "../PageView/PageViewTable/SharedToolbar/SharedSelectedRecordsActions";

export default function ColumnTrashCan() {
  const { setNodeRef, isOver } = useDroppable({
    id: "delete-column",
  });

  return (
    <FloatingToolbar
      className={`d-flex justify-content-center transistion-all ${
        isOver ? "bg-danger" : "bg-white"
      }`}
      minWidth={0}
      ref={setNodeRef}
    >
      <i
        className={`mdi mdi-delete text-danger transistion-all ${
          isOver ? "py-1 px-3" : "px-2"
        } ${isOver ? "text-white" : "text-danger"}`}
        style={{ fontSize: isOver ? 50 : 40 }}
      />
    </FloatingToolbar>
  );
}
